var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 409,
    viewBox: "0 0 1440 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M736.228 90.8581C819.502 84.5221 827.636 137.668 874.716 140.641C905.503 142.586 936.949 107.132 1004.15 99.0045C1101.83 87.1913 1162.13 82.7318 1258.5 106.989C1400.76 142.795 1575.3 408.395 1575.3 408.395H586.084L-207.845 405.87V82.5234C-193.486 80.1934 -136.932 72.5625 -123.342 60.6793C-106.355 45.8253 -97.254 60.6793 -90.5802 60.6793C-83.9065 60.6793 -54.5942 17.797 -43.6736 3.81682C-32.753 -10.1634 -15.7652 23.9134 -3.63113 33.5248C8.50288 43.1362 39.2142 29.6261 60.0726 23.9134C89.9499 15.7306 126.694 38.3733 138.828 47.111C173.224 67.4858 199.651 43.0832 225.723 51.0679C266.002 63.4037 258.332 81.027 309.902 84.5221C361.471 88.0171 443.159 51.6227 461.967 42.8851C522.612 14.7109 587.289 60.6793 623.084 75.5333C658.88 90.3873 712.747 92.6447 736.228 90.8581Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.28047 -109.933) rotate(20.7413) scale(1232.34 375.403)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E754A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19483,
    stopColor: "#DF59C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581608,
    stopColor: "#5673ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2449DA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain3);
export default __webpack_public_path__ + "static/media/mountain3.47e30c92fde41f0fd33ecd3fedd641d3.svg";
export { ForwardRef as ReactComponent };